import React, { useContext, useCallback, useState, useEffect } from 'react';
import _, { trim } from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { IconButton } from '@jutro/legacy/components';
import { useModal } from '@jutro/components';
import { focusNextElement, screenReaderAnnounce } from 'premier-capability-hooks';
import metadata from './OperatorComponent.metadata.json5';
import styles from '../../pages/MarPle/MarPlePage.module.scss'
import messages from './OperatorComponent.messages';
import MovingTrafficViolationsComponent from './subcomponent/MovingTrafficViolations/MovingTrafficViolationsComponent'
import AtFaultaccidentsComponent from './subcomponent/AtFaultaccidents/AtFaultaccidentsComponent'
import { contents } from 'cheerio/lib/api/traversing';
import { TranslatorContext } from '@jutro/legacy/locale';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function OperatorComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, index} = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('OperatorComponent');
    const [accordionStates, updateAccordionStates] = useState([]);
    const modelVM = _.get(submissionVM, pathUpdated)
    const { showConfirm } = useModal();

    modelVM.operatorList.isValidationReq.value = true
    modelVM.autoRecord.isValidationReq.value = true
    modelVM.isValidationReq.value = true

    useEffect(() => {
        if (index === 0) {
            if (_.get(submissionVM.value, `lobData.recMarLine.coverables.operators[${index}].operatorList.firNamFie`) === undefined) {
                _.set(submissionVM.value, `lobData.recMarLine.coverables.operators[${index}].operatorList.firNamFie`,
                    _.get(submissionVM.value, 'baseData.primaryNamedInsured_Ext.firstName')
                );
            }
            if (_.get(submissionVM.value, `lobData.recMarLine.coverables.operators[${index}].operatorList.lasNamFie`) === undefined) {
                _.set(submissionVM.value, `lobData.recMarLine.coverables.operators[${index}].operatorList.lasNamFie`,
                    _.get(submissionVM.value, 'baseData.primaryNamedInsured_Ext.lastName')
                );
            }
        }

        const lastAddedOperator = _.get(submissionVM, `lobData.recMarLine.coverables.operators.children[${index}].value.tempID`, '');
        const addedOperatorCount = _.get(submissionVM, `lobData.recMarLine.coverables.operators.value`, []).length;

      if(addedOperatorCount === index + 1 && lastAddedOperator !=='' ){
        updateAccordionStates([`OperatorAccordionDetails_${index + 1}`]);
      }
    }, [index])

    const handleValueChange = useCallback(
        (value, changedPath) => {
            
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);
            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const checkLicNumberValue = () => {
        if (_.isUndefined(modelVM.value.operatorList.licNumFie)) {
            return true
        }

        if (!_.isUndefined(modelVM.value.operatorList.licNumFie) && modelVM.value.operatorList.licNumFie.trim().length === 0) {
            return true
        }

        return false;
    }

    
    const deleteoperator = useCallback(
        () => {
            const operatorListPath = 'lobData.recMarLine.coverables.operators.value';
            const operator = modelVM.value;
            const operatorList = _.get(submissionVM, operatorListPath);

            showConfirm({
                title: messages.removeOperator,
                message: messages.removeOperatorDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newoperatorList = _.remove(operatorList,
                        (operatorFromList) => _.isEqual(operatorFromList, operator));

                    _.set(submissionVM, newoperatorList, operatorListPath);
                    updateWizardData(submissionVM);
                    setTimeout(() => {
                        screenReaderAnnounce(translator(messages.removedOperator, { opeName: `${trim(operator.operatorList.firNamFie)} ${trim(operator.operatorList.lasNamFie)}` }));
                        focusNextElement(true, 0, 'addOperatorsDetails');
                    }, 0);
                                      
                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData, translator]
    );

    const renderDeleteButton = useCallback(() => {
        const operatorName = `${_.get(modelVM, 'value.operatorList.firNamFie', '')  } ${  _.get(modelVM, 'value.operatorList.lasNamFie', '')}`;

        return (
        <IconButton
                        icon="mi-delete"
                        onClick={() => deleteoperator()}
                         aria-label ={translator(messages.deleteOperator,{opeName: trim(operatorName)})}
                    />  
    );  
}, [deleteoperator, modelVM, translator]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifUnrPleExp3: {
            visible: !_.isUndefined(modelVM.value.operatorList.reltoownFie) && modelVM.value.operatorList.reltoownFie === 'Unrel'
        },
        datofBirFie: {
            required: checkLicNumberValue()
        },
        priFie: {
            defaultValue: index === 0 ? true : false
        },
        MovingTrafficViolationsComponent: {
            id: `MovingTrafficViolation${index}`,
            data: modelVM.autoRecord.movingTrafficViolations,
            updateWizardData,
            submissionVM,
            MovingTrafficViolationsPath: `${pathUpdated}.autoRecord.movingTrafficViolations`
        },
        AtFaultaccidentsComponent: {
            id: `AtFaultaccidents${index}`,
            data: modelVM.autoRecord.atFaultAccidents,
            updateWizardData,
            submissionVM,
            AtFaultaccidentsPath: `${pathUpdated}.autoRecord.atFaultAccidents`
        },
        OperatorAccordionDetails: {            
            title: translator(messages.operator, { count: `${index + 1}` }),
            id: `OperatorAccordionDetails_${index + 1}`
        },
        OperatorAccordion: {
            onUpdateAccordionStates: (accordionStateList) => updateAccordionStates(accordionStateList),
            accordionStates
        },
        actionContainer: {
            content: renderDeleteButton()
        }
    };




    const resolvers = {
        resolveCallbackMap: {
            deleteoperator,
            onValidate
        },
        resolveComponentMap: {
            MovingTrafficViolationsComponent,
            AtFaultaccidentsComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

OperatorComponent.propTypes = wizardProps;
export default withRouter(OperatorComponent);
